import type { Guide } from "./guide";

export const shortcutsGuide: Guide = {
  name: "Shortcuts in CREATE Web",
  internal: "obt02",
  steps: [
    {
      target: ".v-step-0",
      content: "In your canvas, you can zoom by using mousewheel",
      before: (_) =>
        new Promise<void>((resolve, reject) => {
          const stName = document.getElementsByClassName("canvas-step")[0];
          stName.classList.add("v-step-0");
          resolve();
        }),
      params: {
        placement: "bottom",
        strategy: "fixed",
      },
    },
    {
      target: ".v-step-0",
      content: "You can zoom faster by pressing CTRL",
    },
    {
      target: ".v-step-0",
      content: "When you click into the canvas, you can zoom in with CTRL + and out with CTRL -",
    },
    {
      target: ".v-step-0",
      content: "By using Shift + Left Click, you can select multiple statechart elements",
    },
    {
      target: ".v-step-0",
      content: "To Select all elements inside a statechart, press STRG + A",
    },
    {
      target: ".v-step-0",
      content: "Pressing backspace or delete does delete the currently selected elements from the canvas",
    },
    {
      target: ".v-step-0",
      content: "CTRL + Z lets you undo changes in the statechart",
    },
    {
      target: ".v-step-0",
      content: "CTRL + Y lets you redo changes in the statechart",
    },
    {
      target: ".v-step-0",
      content: "With CTRL + C, you can copy the current selection",
    },
    {
      target: ".v-step-0",
      content: "With CTRL + X, you can cut the current selection",
    },
    {
      target: ".v-step-0",
      content: "With CTRL + V, you can paste the clipboard into the canvas",
    },
  ],
};
